import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';

import { InvoicesMonthTitle } from './InvoicesMonthTitle';
import { InvoiceTable } from './InvoiceTable';
import type { DatedInvoices } from './redux/types';

interface Props {
    invoicesMonth: DatedInvoices;
}

export const InvoicesMonth = (props: Props) => {
    const { invoicesMonth } = props;
    return (
        <div className='InvoiceMonth'>
            <br />
            <ExpanderPanel
                title={<InvoicesMonthTitle invoicesMonth={invoicesMonth} />}
                bsStyle='default'
                bodyClassName='padding-0'
            >
                <InvoiceTable invoices={invoicesMonth.invoices} />
            </ExpanderPanel>
        </div>
    );
};
